import store from "src/store"

//@ts-check
export const extractSolidityCompilerVersion = (sourceCode) => {
  const versionExtracted = sourceCode.match(/\s*pragma.*(\d+\.\d+\.\d+)"?;/m)
  
  if (!versionExtracted) {
    return ""
  }
  let startingVersion =  versionExtracted[0].match(/[\d|,|.|e|E|\+]+/g)
  let compOpr = versionExtracted[0].match(/[^\w\s]/);
  let conditionChars = versionExtracted[0].substring(compOpr.index,compOpr.index+2);
  
  let matchFound = '';
  
  if(conditionChars != '<=' && conditionChars != '>=' ){
    if(compOpr[0] === '<'){
      matchFound = 'LOWER';
    }else if(compOpr[0] === '>'){
      matchFound = 'HIGHER';
    }
  }

  var solidityIndex = store.solidityCompilerVersions.findIndex(
    ver => {
      return ver.indexOf(startingVersion[0] + "+") > 0
    } 
  )

  var actualVersion = store.solidityCompilerVersions[solidityIndex];
  
  if(matchFound === 'HIGHER' && store.solidityCompilerVersions[solidityIndex-1] !== undefined){
    actualVersion = store.solidityCompilerVersions[solidityIndex-1]
  }else if(matchFound === 'LOWER' && store.solidityCompilerVersions[solidityIndex+1] !== undefined){
    actualVersion = store.solidityCompilerVersions[solidityIndex+1]
  }
  
  return actualVersion;
}
